<template>
  <div class="vega-system">
    <h1>天女星系</h1>
    <button @click="navigateBack">返回星系地图</button>
    <p>这里是天女星系的内容</p>
  </div>
</template>

<script>
export default {
  name: "VegaSystem",
  methods: {
    navigateBack() {
      this.$router.push("/"); // 返回星系地图
    },
  },
};
</script>

<style scoped>
.vega-system {
  width: 100%;
  height: 100%;
  background-color: #111;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>